export const titleColor = '#000000';
export const primaryTitleColor = '#000000';
export const secondaryTitleColor = "grey"
